/**修改个人资料**/
<template>
  <div class="compileNom">
    <div class="page1 page">
      <div class="pageItem clear headItme">
        <div class="head">
          <span class="headImg" @click="upAvatarStateFn">
            <img v-if="avatar && avatar.length > 0" :src="avatarFn">
            <img v-else src="../../assets/img/yonghu/logo.png">
          </span>
        </div>
      </div>
      <div class="pageItem clear">
        <div class="pageItemTitle">
          名字
        </div>
        <div class="pageItemContent">
          <input v-model="name" placeholder="请输入您的昵称"/>
        </div>
      </div>
      <div class="pageItem clear">
        <div class="pageItemTitle">
          性别
        </div>
        <div class="pageItemContent">
          <span class="genderSelect genderMan " :class="gender?'ShowGenderSelect':''" @click="genderFn('男')">
            <i class="iconfont  icon-nan "></i>
            男
          </span>
          <span class="genderSelect genderWoman" :class="!gender?'ShowGenderSelect':''" @click="genderFn('女')">
            <i class="iconfont icon-xiangxiziliaonv"></i>
            女
          </span>
        </div>
      </div>
      <div class="pageItem clear">
        <div class="pageItemTitle">
          手机号
        </div>
        <div class="pageItemContent">
          <input :value="phone&&phone!==''?phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3'):''" placeholder="请输入您的手机号"
                 readonly/>
        </div>
      </div>
    </div>
    <div class="page2 page">
      <div class="pageItem clear">
        <div class="pageItemTitle">
          紧急联系人姓名
        </div>
        <div class="pageItemContent">
          <input placeholder="请输入您的紧急联系人姓名" v-model="memberEcn"/>
        </div>
      </div>
      <div class="pageItem clear">
        <div class="pageItemTitle">
          紧急联系人电话
        </div>
        <div class="pageItemContent">
          <input placeholder="请输入您的紧急联系人电话"
                 v-model="memberEcp"/>
        </div>
      </div>
      <div class="pageItem clear" v-if="false">
        <div class="pageItemTitle">
          常用目的地
        </div>
        <div class="pageItemContent">
          <xk-site-input @onClick="alwaysAddFn" :placeholder="'请输入常用地'" :name="alwaysAddShowFn"></xk-site-input>
        </div>
      </div>
    </div>
    <div class="saveItem" @click="SaveButFn">
      <span class="saveBut">保存</span>
    </div>
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
    <xk-up-avatar :phone="loginData.passenger?loginData.passenger.phone:''"
                  :imgUrl="avatar"
                  @change="upAvatarFn"
                  v-if="upAvatarState"
    ></xk-up-avatar>
    <xk-upload-mod :state="BoxSave"></xk-upload-mod>
  </div>
</template>

<script>
  import XkHintBox from '../module/hintBox/src/hintBox'
  import { mapGetters } from 'vuex'
  import Toucth from '../../assets/js/method'
  import XkSiteInput from '../module/siteInput/src/siteInput'
  import XkUpImgDom from '../module/upImg/src/upImg'
  import XkUpAvatar from '../module/upAvatar/src/upAvatar.vue'
  import XkUploadMod from '../module/uploadMod/src/uploadMod'

  export default {
    components: {
      XkUploadMod,
      XkUpAvatar,
      XkUpImgDom,
      XkSiteInput,
      XkHintBox
    },
    name: 'compileNom',
    computed: {
      ...mapGetters({
        loginData: 'loginData'
      }),
      SaveFn: function () {
        let that = this
        that.BoxSave = true
      },
      avatarFn () {
        if (this.avatar) {
          return (window.configure.imgUrl + this.avatar)
        } else {
          return false
        }
      },
      alwaysAddShowFn: function () {
        if (this.loginData.passenger) {
          return this.loginData.passenger.other.memberUsual
        }
      }
    },
    data () {
      return {
        gender: false,
        BoxSave: false,
        name: '', // 名称
        phone: '', // 电话
        // alwaysAdd: {
        //   addName: '',
        //   detailAdd: '',
        //   lat: this.loginData ? this.loginData.passenger.other.lat : '',
        //   lng: this.loginData ? this.loginData.passenger.other.lng : ''
        // },
        memberEcn: null, // 紧急人
        memberEcp: null, // 紧急电话
        avatar: null, // 头像地址
        upAvatarState: false,
        hintBox: {
          stateShow: false,
          state: 'yes',
          content: ''
        },
        version: null, // 版本
        headPortrait: null
      }
    },
    watch: {
      loginData (val) {
        console.log('更新', val)
        let passenger = val.passenger
        this.name = passenger.name
        this.phone = passenger.phone
        this.version = passenger.version
        this.avatar = passenger.avatar
        this.gender = passenger.gender === 1
        this.memberEcn = passenger.urgent_name
        this.memberEcp = passenger.urgent_phone
      }
    },
    methods: {
      genderFn: function (type) {
        let that = this
        switch (type) {
          case '男':
            that.gender = true
            break
          case '女':
            that.gender = false
        }
      },
      amendPersonalData: function () {
        let that = this
        that.$store.dispatch('putPassenger', {
          id: window.configure.passengerInfo.id,
          'name': this.name,
          'gender': this.gender ? '1' : '0',
          'phone': this.phone,
          'urgent_name': this.memberEcn,
          'urgent_phone': this.memberEcp,
          'avatar': this.avatar || null,
          'version': this.version,
          fn: function (data) {
            that.BoxSave = false
            if (data && data.code === 1) {
              that.hintBox = {
                stateShow: true,
                state: 'yes',
                content: '保存成功！'
              }
              that.getPassengerFn()
              setTimeout(function () {
                that.hintBox = false
              }, 1500)
            }
          }
        })
      },
      SaveButFn: function () {
        let that = this
        if (this.name !== '') {
          // console.log(this.memberEcp, Toucth.checkPhone(this.memberEcp))
          if (this.memberEcn === '') {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '紧急联系人不能为空'
            }
            setTimeout(function () {
              that.hintBox = false
            }, 1500)
            return false
          }
          if (this.memberEcp !== '') {
            if (!Toucth.checkPhone(this.memberEcp)) {
              that.hintBox = {
                stateShow: true,
                state: 'no',
                content: '请填写正确的紧急联系人电话'
              }
              setTimeout(function () {
                that.hintBox = false
              }, 1500)
              return false
            }
          } else {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '紧急联系人电话不能为空'
            }
            setTimeout(function () {
              that.hintBox = false
            }, 1500)
            return false
          }
          that.BoxSave = true
          that.amendPersonalData()
        } else {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '姓名不能为空！'
          }
          setTimeout(function () {
            that.hintBox = false
          }, 1500)
          return false
        }
      },
      upAvatarFn: function (success) {
        let that = this
        if (success && success.code === 200) {
          that.avatar = success.fileId
          that.hintBox = {
            stateShow: true,
            state: 'yes',
            content: '上传成功！'
          }
          setTimeout(function () {
            that.hintBox.stateShow = false
          }, 1500)
          that.amendPersonalData()
        } else {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '上传失败！'
          }
          setTimeout(function () {
            that.hintBox.stateShow = false
          }, 1500)
        }
        this.upAvatarState = false
      },
      upAvatarStateFn: function () {
        this.upAvatarState = true
      },
      getPassengerFn () { // 获取个人信息
        let that = this
        that.$store.dispatch('getPassenger', {
          id: window.configure.passengerInfo.id
        })
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        that.getPassengerFn()
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .compileNom {
    background-color: #f3f4f5;
    width: 100vw;
    height: 100vh;
    .page {
      margin-bottom: 1rem;
      padding: 0 1rem;
      background-color: #fff;
      .pageItem {
        box-sizing: border-box;
        padding: 0 1rem;
        border-bottom: 1px solid #f3f4f5;
        height: 3.75rem;
        line-height: 3.75rem;
        .pageItemTitle {
          width: 8rem;
          float: left;
          height: 100%;
        }
        .pageItemContent {
          width: calc(~'100% - 8rem');
          float: left;
          .genderSelect {
            box-sizing: border-box;
            display: inline-block;
            vertical-align: middle;
            padding: 0 1rem;
            height: 2rem;
            line-height: 2rem;
            border-radius: 1rem;
            overflow: hidden;
            border: 1px solid #e1e1e1;
            color: #999999;
            transition: 0.3s all;
            background-color: #fff;
            font-size: 1rem;
            i {
              display: inline-block;
              margin-right: 0.9rem;
              font-size: 1rem;
              height: 2rem;
              color: #c5c4c4;
              transition: 0.3s all;
            }
          }
          .genderSelect:nth-child(1) {
            margin-right: 0.5rem;
          }
          .genderSelect:nth-child(2) {
            margin-left: 0.5rem;
          }
          .ShowGenderSelect {
            background-color: #f06553;
            border: 1px solid #f06553;
            color: #fff;
            i {
              color: #fff;
            }
          }
          input {
            display: inline-block;
            vertical-align: middle;
            line-height: 3rem;
            border: none;
            width: 100%;
            box-sizing: border-box;
          }
        }
      }
      .pageItem:nth-last-child(1) {
        border-bottom: none;
      }
      .headItme {
        height: 10rem;
        line-height: 10rem;
        .head {
          width: 100%;
          text-align: center;
          .headImg {
            display: inline-block;
            width: 6rem;
            height: 6rem;
            border-radius: 50%;
            border: 1px solid #eee;
            overflow: hidden;
            position: relative;
            vertical-align: middle;
            img {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
        color: #999999;
      }
    }
    .saveItem {
      padding: 0 1rem;
      height: 3.66666rem;
      line-height: 3.66666rem;
      span {
        color: #fff;
        width: 100%;
        text-align: center;
        background-color: #f06553;
        border-radius: 0.3333rem;
        font-size: 1rem;
      }
    }
    .upAvatar {
      z-index: 300;
    }
  }
</style>



// WEBPACK FOOTER //
// compileNom.vue?61af00f8